/*
 * @Description:
 * @Author: Rabbiter
 * @Date: 2023-03-08 20:38:49
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import echarts from 'echarts'
import axios from 'axios'
import './assets/font/iconfont.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueCookies from 'vue-cookies'
// import './assets/font2/iconfont.css'
import store from '@/vuex/store'
import flexible from 'amfe-flexible'
import '@/utils/rem.js'


Vue.use(flexible);


Vue.use(ElementUI)
Vue.use(VueCookies)

Vue.config.productionTip = false
Vue.prototype.bus = new Vue()
Vue.prototype.$echarts = echarts
Vue.prototype.$axios = axios

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js